import React, { createContext, useContext, useState, useEffect } from 'react';
import isAuth from '../router/isAuth';
import isAdmin from '../router/isAdmin';

import UserService from '../API/UserService';

const AuthContext = createContext();

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Вызывается после логина
  const login = (token) => {
    localStorage.setItem('Authorization', token);
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem('Authorization');
    setIsAuthenticated(false);
    setProfile(null);
  };

  useEffect(() => {
    const init = async () => {
      const token = localStorage.getItem('Authorization');
      if (token) {
        setIsAuthenticated(true);
        try {
          const data = await UserService.getMyProfile();
          setProfile(data);
        } catch {}
      }
      setIsLoading(false);
    };
    init();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, profile, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};